/**
 * Configuration centralisée des seuils de statut pour les tests
 */
import THRESHOLDS from './statusThresholds.json';

// Seuils lus depuis statusThresholds.json, partagé avec la route serveur /api/squads/status :
// >= STABLE = stable, >= WARNING = attention, en dessous = pas stable.
export const STATUS_THRESHOLDS = THRESHOLDS;

export const STATUS_LABELS = {
  STABLE: 'stable',
  WARNING: 'attention',
  UNSTABLE: 'pas stable'
};

/**
 * Calcule le statut d'un environnement ou pipeline basé sur le taux de réussite
 * @param {number} successRate - Taux de réussite en pourcentage (0-100)
 * @param {number} criticalBugsCount - Nombre de bugs critiques (optionnel)
 * @returns {{label: string, color: string}} Objet contenant le label et la couleur du statut
 */
export const getStatusFromSuccessRate = (successRate, criticalBugsCount = 0) => {
  const rate = Number(successRate) || 0;
  const critical = Number(criticalBugsCount) || 0;
  
  // Si des bugs critiques existent, c'est toujours "pas stable"
  if (critical > 0) {
    if (critical === 1) {
      return { label: `${STATUS_LABELS.UNSTABLE} - ${critical} bug critique`, color: 'red' };
    }
    return { label: `${STATUS_LABELS.UNSTABLE} - ${critical} bugs critiques`, color: 'red' };
  }
  
  // Sinon, basé sur le taux de réussite
  if (rate >= STATUS_THRESHOLDS.STABLE) {
    return { label: STATUS_LABELS.STABLE, color: 'green' };
  }
  if (rate >= STATUS_THRESHOLDS.WARNING) {
    return { label: STATUS_LABELS.WARNING, color: 'yellow' };
  }
  return { label: STATUS_LABELS.UNSTABLE, color: 'red' };
};
